// extracted by mini-css-extract-plugin
module.exports = {"shadowBox":"ShadowBox_style_shadowBox__16qR5"};